import { render, staticRenderFns } from "./exhibits-list.vue?vue&type=template&id=0442afd3&scoped=true&"
import script from "./exhibits-list.vue?vue&type=script&lang=js&"
export * from "./exhibits-list.vue?vue&type=script&lang=js&"
import style0 from "./exhibits-list.vue?vue&type=style&index=0&id=0442afd3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0442afd3",
  null
  
)

export default component.exports